import { render, staticRenderFns } from "./7cjg_doc.vue?vue&type=template&id=1ddbc4c8&scoped=true"
import script from "./7cjg_doc.vue?vue&type=script&lang=js"
export * from "./7cjg_doc.vue?vue&type=script&lang=js"
import style0 from "./7cjg_doc.vue?vue&type=style&index=0&id=1ddbc4c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddbc4c8",
  null
  
)

export default component.exports